import { withModalBuilder } from './withModalBuilder'
import { withModal } from './withModal'
import AlertModal from './AlertModal'

export const AlertModalContainer = withModalBuilder({ isStatic: true })(
  AlertModal,
)

export const withAlertModal = options => withModal(AlertModalContainer, options)



// WEBPACK FOOTER //
// ./src/modules/modal/withAlertModal.js